// Shared date/time formatting. API timestamps are GMT/UTC (RFC3339); they are
// rendered in the browser's local timezone. A zone-less date-time string (the
// dev DB may omit the `Z`) is treated as UTC rather than local.

import { format, formatDistanceToNow } from "date-fns";

const EM_DASH = "—";

// Parse an API timestamp to a Date. A date-time string with no zone designator
// is assumed UTC. Returns null for empty/invalid input.
export const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  let str = String(value).trim();
  if (/T\d{2}:\d{2}/.test(str) && !/(Z|[+-]\d{2}:?\d{2})$/.test(str)) {
    str += "Z";
  }
  const d = new Date(str);
  return Number.isNaN(d.getTime()) ? null : d;
};

// Absolute date + time in local time, e.g. "May 19, 2026, 4:00 PM".
export const formatDateTime = (value) => {
  const d = toDate(value);
  if (!d) return EM_DASH;
  try {
    return format(d, "PP, p");
  } catch {
    return EM_DASH;
  }
};

// Date only, in local time, e.g. "May 19, 2026".
export const formatDate = (value) => {
  const d = toDate(value);
  if (!d) return EM_DASH;
  try {
    return format(d, "PP");
  } catch {
    return EM_DASH;
  }
};

// Relative time, e.g. "3 hours ago".
export const formatRelative = (value) => {
  const d = toDate(value);
  if (!d) return EM_DASH;
  try {
    return formatDistanceToNow(d, { addSuffix: true });
  } catch {
    return EM_DASH;
  }
};
